import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { WjNavModule } from '@grapecity/wijmo.angular2.nav';
import { WjInputModule } from '@grapecity/wijmo.angular2.input';

import { AppCommonsModule } from '../../app-commons.module';
import { PlessSharedModule } from '../../../shared/pless-shared.module';

import { KYMW0909Component } from './kymw0909.component';

/**
 * プロモ設定画面 ポイント交換商品モジュール設定クラス
 *
 * @export KYMW0909Module
 * @class KYMW0909Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    AppCommonsModule,
    PlessSharedModule,
    WjNavModule,
    WjGridModule,
    WjInputModule,
  ],
  declarations: [
    KYMW0909Component,
  ],
  providers: [
  ],
})
export class KYMW0909Module { }
